import { useEffect } from 'react'
import { Control, UseFormSetValue, useWatch } from 'react-hook-form'
import { useGetListPriceBaseQuery } from '../services/priceBase'
import { useGetListShellTypeQuery } from '../services/shellType'
import { get } from 'lodash'

interface UsePriceSuggestionProps {
  control: Control<any>
  setValue: UseFormSetValue<any>
  onFieldChange: (field: string, name: any, value: any) => void
}

export const usePriceSuggestion = ({ control, setValue, onFieldChange }: UsePriceSuggestionProps) => {
  // Watch relevant fields
  const customerId = useWatch({ control, name: 'orderInfo.customerId' })
  const containerId = useWatch({ control, name: 'goodsInfo.containerId' })
  const placeStart = useWatch({ control, name: 'transferOrder.placeStart' })
  const placeEnd = useWatch({ control, name: 'transferOrder.placeEnd' })

  // Fetch shell types to map containerId to name
  const { data: shellTypesData } = useGetListShellTypeQuery({})
  const shellTypes = shellTypesData?.data?.rows || []

  // Determine vehicleType string from containerId
  const selectedShell = shellTypes.find((s: any) => s.id.toString() === containerId?.toString())
  const vehicleType = selectedShell ? selectedShell.name : ''

  // Fetch suggested price from PriceBase
  const { data: priceBaseData, isFetching } = useGetListPriceBaseQuery(
    {
      customerId: customerId || undefined,
      vehicleType: vehicleType || undefined,
      placeStart: placeStart || undefined,
      placeEnd: placeEnd || undefined,
      limit: 1,
      page: 1
    },
    {
      skip: !placeStart || !placeEnd || !vehicleType,
      refetchOnMountOrArgChange: true
    }
  )

  // Watch current price to avoid infinite loop
  const currentPrice = useWatch({ control, name: 'freightCollect.cuoc.monney' })

  useEffect(() => {
    if (!isFetching && priceBaseData?.data?.rows && priceBaseData.data.rows.length > 0) {
      const bestMatch = priceBaseData.data.rows[0]

      // Only set if price is different and not manually edited (is empty or 0)
      if (bestMatch.unitPrice && (!currentPrice || currentPrice === '0' || currentPrice === 0)) {
        onFieldChange('freightCollect.cuoc', 'monney', bestMatch.unitPrice.toString())
      }
    }
  }, [priceBaseData, isFetching, onFieldChange, currentPrice])

  return { isFetchingSuggestion: isFetching }
}
